module.exports = __webpack_public_path__ + "assets/5471d367c0cabaa0614b6bd8da90fb08.svg";